module.exports = __webpack_public_path__ + "cristal_lopez--4d731833.jpg";


//////////////////
// WEBPACK FOOTER
// ./_source/img/candidatos/cristal_lopez.jpg
// module id = 158
// module chunks = 0